import {
  OpenUrlTarget,
  PanelContainer,
  openURL,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';

const SaleOfInformationModule: React.FC = () => {
  return (
    <PanelContainer
      defaultOpen={false}
      icon="info-circle"
      panelTitle="Sale of Information"
      bodyTitle="Do Not Sell Requests"
      primaryCTA={{
        label: 'Learn More',
        onPress: () =>
          openURL(
            'https://www.caesars.com/corporate/corporate-social-responsibility/play/privacyrequests',
            OpenUrlTarget.BLANK
          ),
      }}
      body='Under the CCPA and Nevada law, a Caesars Entertainment customer who is a California or Nevada resident can opt out of the sale of their personal information. A "sale" under the CCPA also includes the sharing of personal information with a third party in exchange for any valuable benefit.'
    />
  );
};

export default SaleOfInformationModule;
